export default "__VITE_ASSET__B9DJoMm2__"